/*
Composable useShowDashboardNotifications handles the global state of showing
notification sidebar. The composable is used within the navigation controls.
*/
export const useDatePicker = () => {
  const route = useRoute()

  const currentDateTimeString = (): string => {
    const currentDate = new Date()
    return dateToLocalisedISOString(currentDate).substring(0, 16)
  }

  const showDatePicker = useState('showDatePicker', () => <boolean>false)

  const threeHoursAgo = transformDateToHoursAgo(new Date(), 3)
  const dateNow = new Date()
  const dateNowISO = dateNow.toISOString()

  const selectedTimeRangeLabel = useState('timeRangeLabel', () => <string | undefined>'Select time range')

  const fromDateParam = useState('fromDate', () => <string | null>route.query.from || threeHoursAgo)
  const toDateParam = useState('toDate', () => <string | null>route.query.to || dateNowISO)

  watch(
    () => route.query,
    (newQuery) => {
      if (newQuery.from) {
        fromDateParam.value = newQuery.from as string
      }
      if (newQuery.to) {
        toDateParam.value = newQuery.to as string
      }
      if (!newQuery.from && !newQuery.to) {
        fromDateParam.value = threeHoursAgo
        toDateParam.value = dateNowISO
      }
    },
    { deep: true }
  )

  const toggleShowDatePicker = () => {
    showDatePicker.value = !showDatePicker.value
  }

  return { currentDateTimeString, showDatePicker, toggleShowDatePicker, fromDateParam, toDateParam, selectedTimeRangeLabel }
}
